import type { JSX } from 'react';
import { PublicPageHeading } from '@/components/public/PublicPageHeading';
import { PublicUnitCard } from '@/components/public/units';
import { PublicPageSection } from '@/layouts/PublicPageLayout';
import type { PublicPropertySummary, PublishedUnitSummary } from '@/lib/types/publicProperty';

export type RecentUnitEntry = {
  property: PublicPropertySummary;
  unit: PublishedUnitSummary;
};

export function RecentUnitsSection({
  recentUnits,
}: {
  recentUnits: RecentUnitEntry[];
}): JSX.Element | null {
  if (recentUnits.length === 0) {
    return null;
  }

  return (
    <PublicPageSection tone="base" aria-label="Recently viewed units">
      <PublicPageHeading
        eyebrow="Recently viewed"
        title="Pick up where you left off"
        description="Continue exploring suites you recently opened, with the latest availability details."
        layout="stacked"
      />
      <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {recentUnits.map(({ property, unit }) => (
          <PublicUnitCard
            key={`${property.id}-${unit.id}`}
            property={property}
            unit={unit}
            href={`/properties/${property.propertyCode.toLowerCase()}/units/${unit.id}`}
          />
        ))}
      </div>
    </PublicPageSection>
  );
}
